import React, {useState} from 'react';
import {Button, Stack} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {finalize} from 'rxjs';
import {useSnackbar} from 'notistack';

import ModalComponent from '@components/modal/Modal.component';
import {auditsService} from '@store/audits/audits.service';
import {templatesService} from '@store/audits/templates/templates.service';


export enum AuditGroupedActionEnum {
    AUDIT = 'AUDIT',
    TEMPLATE = 'TEMPLATE'
}
interface AuditGroupedActionModalProps {
    handleClose: () => void;
    type: AuditGroupedActionEnum;
}

const AuditGroupedActionModal = (props: AuditGroupedActionModalProps) => {
    const {handleClose, type} = props;

    const {t} = useTranslation();
    const {enqueueSnackbar} = useSnackbar();

    const [loading, setLoading] = useState(false);

    const handleDelete = () => {

        setLoading(true);
        if (type === AuditGroupedActionEnum.AUDIT) {
            auditsService.deleteAudits().pipe(finalize(() => setLoading(false))).subscribe({
                next: (ids) => {
                    enqueueSnackbar(t('audits.success.delete', {count: ids.length}), {variant: 'success'});
                    handleClose();
                },
                error: (err) => enqueueSnackbar(err.text, err.options),
            });
        } else if (type === AuditGroupedActionEnum.TEMPLATE) {
            templatesService.deleteAuditTemplates().pipe(finalize(() => setLoading(false))).subscribe({
                next: (ids) => {
                    enqueueSnackbar(t('templates.success.delete', {count: ids.length}), {variant: 'success'});
                    handleClose();
                },
                error: (err) => enqueueSnackbar(err.text, err.options),
            });
        }

    };

    return (
        <ModalComponent
            title={t('global.groupedAction')}
            handleClose={handleClose}
            content={(
                <Stack width="70%" spacing={2} pt="55px" pb="10px">
                </Stack>
            )}
            actions={(
                <>
                    <Button variant="contained" disabled={loading} onClick={handleDelete} color="error">
                        {t('global.delete')}
                    </Button>
                    <Button
                        variant="contained"
                        disabled={true}
                        onClick={() => console.log('salut')}
                        color="primary">
                        {t('global.save')}
                    </Button>
                </>
            )}/>
    );
};

export default AuditGroupedActionModal;
